import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

/* CSS */

import '../../shared/components/form/inputDefault.css'

/* form */
import Input from "../../shared/components/form/input"

/* Hooks */
import useMyPermission from '../../hooks/useMyPermission'

import ListCommissionRow from './ListRow/ListCommissionRow'
import Modal from '../../shared/modal/Modal'
import NewCommission from './NewCommission'
import Button from '../../shared/components/Button/Button'


function Commission({ selectItem, handleOnSelectItem, selectedData }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [commissions, setCommissions] = useState([])
    const [modalNew, setModalNew] = useState(false)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionNew = checkPermission(myPermission, "commission_create")
    const myPermissionView = checkPermission(myPermission, "commission_view")
    const myPermissionEdit = checkPermission(myPermission, "commission_edit")
    const myPermissionDelete = checkPermission(myPermission, "commission_delete")

    /* get all function */
    const getAll = () => {
        api.get(`/commission/getall`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                setCommissions(response.data.commissions)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    /* use effect */
    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    /* ----------------------- Search function ---------------------------------- */
    const filter = useMemo(() => {
        return commissions.filter((item) => item.commission.toString().includes(search))
    }, [commissions, search])

    function handleSearch(e) {
        setSearch(e.target.value)
    }

    if (!load) {
        return <div className="pg-loading">Carregando comissões...</div>
    }

    /* PAGE */
    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Comissões</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {myPermissionNew && (
                                <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>
                            )}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar por % de comissão..."
                                    value={search}
                                    handleOnChange={handleSearch}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'comissão' : 'comissões'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListCommissionRow
                        dataArray={filter}
                        handleOnSuccess={getAll}
                        handleOnSelectItem={handleOnSelectItem}
                        myPermissionEdit={myPermissionEdit}
                        myPermissionDelete={myPermissionDelete}
                        myPermissionView={myPermissionView}
                        selectItem={selectItem}
                        selectedData={selectedData}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhuma comissão encontrada</p>
                        <p className="pg-empty-subtitle">
                            {commissions.length === 0
                                ? 'Cadastre a primeira comissão para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={80}
                content={
                    <NewCommission btCancelAction={() => setModalNew(false)} handleOnSuccess={() => { setModalNew(false); getAll() }} />
                }
            />

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar comissões</p>
        </div>
    )
}

export default Commission
